<template>
  <div>
    <!-- 상품추가 버튼 -->
    <div class="d-flex justify-end align-center">
      <div class="mr-4">
        <span class="attention-coment-1">
          <v-icon>mdi-alert-circle</v-icon>
          캠페인 등록 후, 상품(지면) 선택 및 세부 설정이 가능합니다!
        </span>
      </div>
      <v-btn
        large
        depressed
        max-height="40px"
        color="#fecd06"
        class="button-type-1"
        @click.stop="goAddCampaignInventoies"
      >
        <v-icon left> mdi-plus </v-icon>
        상품추가
      </v-btn>
    </div>
    <!--// 상품추가 버튼 -->
    <div class="text-total-1 mb-3 mt-2">
      총 <strong> {{ this.totalInventories.length || 0 }}</strong
      >건 입니다.
    </div>
    <template v-if="mediasList.length > 0">
      <div
        class="accodion-type-1 mb-8"
        v-for="(media, i) in mediasList"
        :key="i"
      >
        <div class="accodion-head">
          <span class="thumb pl-0">
            <img
              :src="media.logo"
              style="width: 40px; height: 40px; border-radius: 4px"
            />
          </span>
          <span class="tit">
            {{ media.name }}
          </span>
          <a
            href=""
            class="arrow"
            :class="{
              active:
                accodionState[i] && accodionState[i].state
                  ? accodionState[i].state
                  : false,
            }"
            @click.prevent="toggleAccodion(i)"
          >
            <v-icon>mdi-chevron-up</v-icon>
          </a>
        </div>
        <v-expand-transition>
          <div
            class="accodion-body"
            v-if="
              accodionState[i] && accodionState[i].state
                ? accodionState[i].state
                : false
            "
          >
            <v-data-table
              :headers="accodionTblHeaders"
              :items="media.inventories"
              :items-per-page="-1"
              class="board-list-1"
              hide-default-footer
            >
              <template v-slot:body="{ items }">
                <tbody v-if="items.length > 0">
                  <tr v-for="(item, j) in items" :key="j">
                    <td>
                      <a
                        href="javascript:void(0);"
                        style="color: transparent"
                        @click.prevent="openRemoveConfirmPopup(item.id)"
                      >
                        <v-icon color="#fecd00">mdi-delete</v-icon>
                      </a>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        @click="
                          media.version === 1
                            ? viewDetailLineItem(item, i, j)
                            : viewDetailLineItemV2(item)
                        "
                        >{{ item.name }}</a
                      >
                    </td>
                    <td>
                      <a href="javascript:void(0);" @click="preview(item)"
                        >미리보기</a
                      >
                    </td>
                    <td>
                      <div class="datepicker-type-1">
                        <v-icon>mdi-calendar-blank</v-icon>
                        <date-range-picker
                          v-model="item.dateRange"
                          :ranges="false"
                          :date-format="dateFormat"
                          :locale-data="localeData"
                          :time-picker="true"
                          :time-picker-seconds="true"
                          :time-picker-increment="1"
                          opens="right"
                          @update="updateDateRange(item)"
                        ></date-range-picker>
                      </div>
                    </td>

                    <td>
                      <a
                        href="javascript:void(0);"
                        style="color: transparent"
                        @click="viewSchedule(item, media.id)"
                      >
                        <v-icon color="#fecd00"
                          >mdi-calendar-text-outline</v-icon
                        >
                      </a>
                    </td>
                    <td>
                      <span
                        v-for="(opt, index) in item.options"
                        :key="index"
                        class="tag"
                        >{{ opt.name }}
                      </span>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        style="color: transparent"
                        @click="viewNote(item)"
                      >
                        <v-icon color="#fecd00">mdi-note-outline</v-icon>
                      </a>
                    </td>
                    <td>
                      <v-switch
                        inset
                        color="#fecd00"
                        v-model="item.switch"
                        :label="item.switch ? 'ON' : 'OFF'"
                        @change="changeIsValid(item, j)"
                        class="switch-type-1"
                        hide-details="hide"
                      ></v-switch>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr></tr>
                </tbody>
              </template>
            </v-data-table>
          </div>
        </v-expand-transition>
      </div>
    </template>
    <template v-else>
      <div
        style="
          font-size: 14px;
          color: #666;
          padding: 20px 0;
          text-align: center;
          border-top: 1px solid #eee;
          border-bottom: 1px solid #eee;
          margin-bottom: 30px;
        "
      >
        등록된 상품(지면)이 없습니다. "상품추가" 버튼을 통해 집행할 매체/지면을
        선택하세요.
      </div>
    </template>
    <div class="btn-box d-flex justify-end">
      <v-btn
        large
        depressed
        max-height="40px"
        color="#fecd06"
        class="button-type-1"
        @click.prevent="goHistoryPage"
      >
        완료
      </v-btn>
    </div>

    <!-- 세부지면 라인 아이템 -->
    <div id="detailLineItem" class="mt-16 pb-md-12">
      <keep-alive>
        <div v-if="inventoryType && mediaVersion === 1" :key="this.inventoryId">
          <component
            :is="detailComponent"
            :propsInventory="inventory"
            :propsInventoryId="inventoryId"
            :propsLineItem="lineItem"
            :propsDateRange="postDateRange"
            :propsAdvertiserId="advertiserId"
            @close:detail="closeDetailLineItem"
            @upadate:campaignInfo="listCampaignInventories"
          />
        </div>
        <div v-else-if="mediaVersion === 2">
          <component
            :is="detailComponent"
            :propInventory="inventory"
            :propAdvertiserId="advertiserId"
            @reload="listCampaignInventories"
          />
        </div>
      </keep-alive>
    </div>
    <SystemAlert v-model="confirmSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="removeLineItems"
        >
          확인
        </v-btn>
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fff"
          class="button-type-1 ml-2"
          @click.stop="confirmSystemAlert = false"
        >
          취소
        </v-btn>
      </div>
    </SystemAlert>
    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="closePopup"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>

    <PreviewModal v-model="showPreview" :propsItem="previewItem"></PreviewModal>
    <NoteModal v-model="showNote" :propsItem="previewItem"></NoteModal>
    <div v-if="showSchedule">
      <ScheduleModal
        v-model="showSchedule"
        :propsItem="previewItem"
        :propsMediaId="mediaId"
      ></ScheduleModal>
    </div>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import DateRangePicker from 'vue2-daterange-picker';
import { toISOFormattedDate } from '@/utils/validation';
import {
  detailCampaign,
  updateDetailCampaignLineItem,
  deleteCampaignLineItems,
} from '@/api/campaign';
import SystemAlert from '~@/modal/SystemAlert.vue';
import PreviewModal from '@/components/modal/PreviewModal.vue';
import NoteModal from '@/components/modal/NoteModal.vue';
import ScheduleModal from '@/components/modal/ScheduleModal.vue';
import { campaignDetailLineItemMapping } from '@/utils/mapping';

import moment from 'moment';

let defaultStartAt = new Date();
defaultStartAt.setHours(0, 0, 0, 0);
defaultStartAt = moment(defaultStartAt);

let defaultEndAt = new Date();
defaultEndAt.setHours(23, 59, 0, 0);
defaultEndAt = moment(defaultEndAt).add(1, 'months');

export default {
  components: {
    DateRangePicker,
    SystemAlert,
    PreviewModal,
    NoteModal,
    ScheduleModal,
  },
  data: () => ({
    mediaVersion: null,
    detailComponent: null,
    showSystemAlert: false,
    confirmSystemAlert: false,
    logResult: '',
    showPreview: false,
    previewItem: {},
    showNote: false,
    showSchedule: false,
    campaignInfo: {},
    mediaId: '',

    dateRange: [
      {
        startDate: defaultStartAt,
        endDate: defaultEndAt,
      },
    ],
    postDateRange: {
      startDate: defaultStartAt,
      endDate: defaultEndAt,
    },

    localeData: {
      format: `yyyy-mm-dd HH:MM:ss`,
      applyLabel: '확인',
      cancelLabel: '취소',
      separator: '　~　',
    },

    accodionState: [],

    accodionTblHeaders: [
      { text: '', value: 'delete', width: '6%', sortable: false },
      { text: '지면명', value: 'name', width: '12%', sortable: false },
      {
        text: '노출 지면 샘플',
        value: 'sample',
        width: '10%',
        sortable: false,
      },
      { text: '노출기간', value: '', width: '36%', sortable: false },
      { text: '스케줄', value: 'schedule', width: '5%', sortable: false },
      {
        text: '광고지면 세부옵션',
        value: 'options',
        width: '15%',
        sortable: false,
      },
      { text: '지면 메모', value: 'note', width: '7%', sortable: false },
      { text: '노출', value: 'expose', width: '9%', sortable: false },
    ],

    mediasList: [],

    inventoryType: '',
    inventoryId: '',
    inventory: {},
    lineItem: {},
    editId: '',
    totalInventories: [],
  }),
  computed: {},
  methods: {
    dateFormat(classes, date) {
      if (!classes.disabled) {
        if (date < this.$moment(this.campaignInfo.start_at)) {
          classes.disabled = true;
        }
        if (date > this.$moment(this.campaignInfo.end_at)) {
          classes.disabled = true;
        }
      }
      return classes;
    },

    toggleAccodion(i) {
      this.accodionState[i].state = !this.accodionState[i].state;
    },
    async listCampaignInventories() {
      const campaignId = this.$route.params.id;
      try {
        const { data } = await detailCampaign(campaignId);
        this.campaignInfo = data.row;
        this.advertiserId = data.row.advertiser.id;
        this.mediasList = data.row.medias;
        this.mediasList.forEach(media => {
          this.accodionState.push({ state: true });
          media.inventories.forEach(inventory => {
            let obj = {
              startDate: inventory.start_at,
              endDate: inventory.end_at,
            };
            inventory.dateRange = obj;

            inventory.is_valid === 'N'
              ? (inventory.switch = false)
              : (inventory.switch = true);
            this.totalInventories.push(inventory);
          });
        });
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },
    async changeIsValid(item) {
      if (!item.lineitems[0].lris && item.lineitems[0].lris.length === 0) {
        this.showSystemAlert = true;
        this.logResult = `등록된 소재가 없습니다.<br> 소재 등록 후 다시 시도해주세요.`;
        await this.listCampaignInventories();
      } else {
        const lrihasResource = item.lineitems[0].lris.some(lri => {
          return lri.resources && lri.resources.length > 0;
        });
        //console.log('lrihasResource', lrihasResource);
        if (!lrihasResource) {
          this.showSystemAlert = true;
          this.logResult = `등록된 소재가 없습니다.<br> 소재 등록 후 다시 시도해주세요.`;
          await this.listCampaignInventories();
        } else {
          this.saveLineItem(item);
        }
      }
    },
    async saveLineItem(item) {
      try {
        const campaignId = this.$route.params.id;
        const inventoryId = item.id;
        const lineItemId = item.lineitems[0].id;
        let start_at = toISOFormattedDate(new Date(item.start_at));
        let end_at = toISOFormattedDate(new Date(item.end_at));

        let is_valid = item.switch ? 'Y' : 'N';

        let updateData = {
          is_valid: is_valid,
          start_at: start_at,
          end_at: end_at,
        };

        const { data } = await updateDetailCampaignLineItem(
          campaignId,
          inventoryId,
          lineItemId,
          updateData,
        );
        //if (data.result === 'success') {
        //	this.showSystemAlert = true;
        //	this.logResult = `수정 되었습니다.`;
        //}
        bus.$emit('end:spinner');
        await this.listCampaignInventories();
      } catch (error) {
        const { data } = error.response;
        if (data.result === 'OutRange') {
          this.showSystemAlert = true;
          this.logResult = `[ ${item.name} ] 지면의 시작/종료 기간은 캠페인의 시작/종료일과 <br>등록한 소재의 시작/종료일 범위 내에서만 설정 가능합니다.`;
        } else if (data.result === 'IsAlreadyReserved') {
          this.logResult = `선택하신 캠페인에 포함된 상품(지면)중 <br>현재 다른 캠페인에서 사용중인 지면이 <br>포함되어 있습니다.<br><br>지면별 일정을 확인 / 수정후<br>다시 시도해주시기 바랍니다.`;
          this.showSystemAlert = true;
        } else {
          return false;
        }
        await this.listCampaignInventories();
      }
    },

    async updateDateRange(item) {
      item.start_at = item.dateRange.startDate;
      item.end_at = item.dateRange.endDate;
      await this.saveLineItem(item);
    },
    openRemoveConfirmPopup(id) {
      this.logResult = `선택한 지면을 캠페인에서<br>삭제하시겠습니까?<br>삭제후 해당 지면은 더이상 캠페인에서<br>출력 되지 않습니다.`;
      this.confirmSystemAlert = true;
      this.editId = id;
    },
    async removeLineItems() {
      bus.$emit('start:spinner');
      this.confirmSystemAlert = false;
      try {
        const campaignId = this.$route.params.id;
        const inventoryId = this.editId;

        const { data } = await deleteCampaignLineItems(campaignId, inventoryId);
        this.inventoryType = '';
        await this.listCampaignInventories();
        bus.$emit('end:spinner');
      } catch (error) {
        console.log(error.response);
      }
    },

    goAddCampaignInventoies() {
      const id = this.$route.params.id;
      this.$router
        .push({ path: `/campaign/${id}/inventories_add` })
        .catch(() => {});
    },
    viewDetailLineItem(item) {
      this.clearDetailLineItem();
      this.mediaVersion = 1;
      this.inventory = item;
      this.inventoryId = item.id;
      this.inventoryType = item.type;
      this.postDateRange.startDate = item.start_at;
      this.postDateRange.endDate = item.end_at;
      this.lineItem = item.lineitems[0];

      const path = campaignDetailLineItemMapping[this.inventoryType];
      this.setDetailComponent(path);
    },
    setDetailComponent(path) {
      path = path.replace('@/views/campaign/details', './details');
      import(`${path}`).then(module => {
        this.detailComponent = module.default;
      });
    },
    clearDetailLineItem() {
      this.mediaVersion = null;
      this.inventory = null;
      this.inventoryId = null;
      this.inventoryType = null;
      this.postDateRange.startDate = null;
      this.postDateRange.endDate = null;
      this.lineItem = null;
      this.detailComponent = null;
    },
    viewDetailLineItemV2(inventory) {
      this.clearDetailLineItem();
      this.mediaVersion = 2;
      this.inventory = inventory;

      const path = './details/v2/detailLineItem.vue';
      this.setDetailComponent(path);
    },
    preview(item) {
      this.showPreview = true;
      this.previewItem = item;
    },
    viewNote(item) {
      this.showNote = true;
      this.previewItem = item;
    },
    viewSchedule(item, mediaId) {
      this.showSchedule = true;
      this.previewItem = item;
      this.mediaId = mediaId;
    },
    closePopup() {
      this.showSystemAlert = false;
      this.logResult = '';
    },
    closeDetailLineItem(data) {
      this.inventoryType = null;
    },
    goHistoryPage() {
      this.$router.go(-2);
    },
  },
  created() {
    bus.$emit('start:spinner');
    this.listCampaignInventories();
  },
};
</script>

<style lang="scss" scoped>
.container-box .v-data-table__wrapper {
  overflow-x: initial !important;
  overflow-y: initial !important;
}
.container-box .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
</style>
